import Item from './item'

export default class Regular {
  constructor(parent) {
    this._items = [];
    this.loading = false;
    this.$parent = parent;
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }

  get dictionary() {
    return this.$parent.dictionary;
  }

  get agreement() {
    return this.$parent.agreement;
  }

  get value() {
    return this._items.reduce((sum, regular) => Math.round(sum * 1000000000000 + regular.sum * 1000000000000) / 1000000000000, 0)
  }

  get debt() {
    return this._items[0] ? this._items[0].debt : 0
  }

  add(list) {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      Promise
        .all(list
          .filter(i => !self._items.find(regular => regular.id === i.value))
          .map(i => {
            const regular = new Item(self, i.value);
            return regular.add();
          })
        )
        .then(regulars => {
          self._items = self._items.concat(regulars);
          self.loading = false;
          if (!self.id) {
            self.$parent.sum = self.value;
          }
          resolve(self);
        }, (err) => {
          self.loading = false;
          reject(err);
        });
    });
  }

  edit(data) {
    const self = this;
    return new Promise(async (resolve, reject) => {
      const regular = new Item(self, data.RegularPaymentId);
      await regular.get().catch(reject);
      self._items.push(regular);
      regular.sum = data.Spread;
      resolve();
    });
  }

  remove(regular) {
    this._items.remove(regular);
    regular.agreements
      .reduce((arr, agreement) => {
        if (!this._items.find(i => i.agreements.find(j => j.code === agreement.code))) {
          arr.push(agreement.code);
        }
        return arr;
      }, [])
      .forEach(code => {
        this.$parent.agreement.remove(code);
      });
    this.$parent.agreement.tab = this.$parent.agreement.items[0] ? this.$parent.agreement.items[0].code : '';
  }
}